import React from "react";
import { Box, Typography } from "@mui/material";
import "./HowItWorks.css";

const steps = [
    {
        title: "Ask Questions",
        desc: "Post your queries or challenges anytime to get support from the community.",
        icon: "/images/Home/Chat Help.png",
    },
    {
        title: "Explore Topics",
        desc: "Browse and filter questions by technology or skill to discover relevant discussions.",
        icon: "/images/Home/Search.png",
    },
    {
        title: "Answer & Get Answers",
        desc: "Contribute by answering others questions and receive solutions to your questions.",
        icon: "/images/Home/Edit Space.png",
    },
    {
        title: "Grow Together",
        desc: "Help create a shared learning ecosystem.",
        icon: "/images/Home/grow.png",
    },
];

function HowItWorks() {
    return (
        <Box className="howItWorksWrapper">
             <Typography className="howItWorksTitle" variant="h5">
                How it works?
            </Typography>

            {/*<Box className="howItWorksSteps">
                {steps.map((step, index) => {
                    const dottedBorderImg =
                        index === steps.length - 1
                            ? "/images/Home/dottedBorderLast.png"
                            : "/images/Home/dottedBorder.png";

                    return (
                        <Box key={index} className="howItWorksCardWrapper">
                            <img
                                src={process.env.PUBLIC_URL + dottedBorderImg}
                                alt="dotted-border"
                                className="howItWorksDottedBorder"
                            />
                            <Box className="howItWorksCard">
                                <Box className="howItWorksLeftBar" />

                                <img
                                    src={process.env.PUBLIC_URL + step.icon}
                                    alt={step.title}
                                    className="howItWorksIcon"
                                />

                                <Typography className="howItWorksCardTitle">
                                    {step.title}
                                </Typography>

                                <Typography className="howItWorksCardDesc">
                                    {step.desc}
                                </Typography>
                            </Box>

                            {index !== steps.length - 1 && (
                                <>
                                    <Box className="arrowSection">
                                        <img
                                            src={process.env.PUBLIC_URL + "/images/Home/arrowConnector.png"}
                                            alt="arrow"
                                            className="howItWorksArrowIcon"
                                        />
                                    </Box>

                                    <img
                                        src={process.env.PUBLIC_URL + "/images/Home/greyrectangleconnector.png"}
                                        alt="connector"
                                        className="howItWorksConnector"
                                    />
                                </>
                            )}
                        </Box>
                    );
                })}

            </Box> */}
            <img
            src={process.env.PUBLIC_URL + "/images/Home/howItWorksImg.png"}
            alt="howItWorks"
            className="howItWorksImg"
          />
        </Box>
    );
}

export default HowItWorks;
